module.exports = __webpack_public_path__ + "static/img/mpdpImgTwo4.72d7eba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mpdpImgTwo4.png
// module id = 1zcL
// module chunks = 2